// import isBreakpoint from '../lib/isBreakpoint'
import Component from '../lib/Component'

export default class MobileNav extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.navToggle = this.elem.querySelector('.js-MobileNav__toggle')
    this.nav = this.elem.querySelector('.js-MobileNav__nav')
    this.navIsOpen = false
    this.breakpoint = 859
  }

  closeNav () {
    this.removeClass('_nav_open')
      .removeClass('_nav_open', this.nav)
      .addAnimationClass('_nav_closed', this.nav)
      .then(() => {
        this.removeClass(['_nav_closed', '_nav_open'], this.nav)
          .removeClass([
            '_scroll_locked',
            '_mobile_nav_open'
          ], document.documentElement)
        this.navIsOpen = false
      })
  }

  openNav () {
    this.addClass('_nav_open')
      .addClass(['_scroll_locked', '_mobile_nav_open'], document.documentElement)
      .addAnimationClass('_nav_open', this.nav)
      .then(() => {
        this.navIsOpen = true
      })
  }

  toggleNav () {
    let action = this.navIsOpen ? 'close' : 'open'
    this.APP.events.publish(`MobileNav:${action}`)
  }

  init () {
    this.APP.events.subscribe('MobileNav:open', this.openNav.bind(this))
    this.APP.events.subscribe('MobileNav:close', this.closeNav.bind(this))
    this.navToggle.addEventListener('click', this.toggleNav.bind(this))

    window.addEventListener('resize', () => {
      if (this.navIsOpen) {
        let winWidth = window.innerWidth
        if (winWidth >= this.breakpoint) {
          this.APP.events.publish('MobileNav:close')
        }
      }
    })
  }
}
